import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Enrollment } from '../enrollments/enrollments.model';
import { Course, Invite } from './courses.model';
import { Page } from '../model';
import { User } from '../users/users.model';




@Injectable({
  providedIn: 'root'
})
export class CoursesService {

  constructor(private http: HttpClient) {
  }

  getCourses(): Observable<Course[]> {
    return this.http.get<Course[]>(
      `${environment.apiHost}/courses`,
    ) ;
  }

  getCourse(id: string): Observable<Course> {
    return this.http.get<Course>(
      `${environment.apiHost}/courses/${id}`,
    ) ;
  }

  createCourse(course:Course): Observable<Course> {
    return this.http.post<Course>(
      `${environment.apiHost}/courses`,
      course
    ) ;
  }

  updateCourse(course:Course): Observable<Course> {
    return this.http.post<Course>(
      `${environment.apiHost}/courses/${course.id}`,
      course
    ) as Observable<Course>;
  }

  getFullCourseName(course: Course) : string {

    if (course.year && course.session) {
      return `${course.name} (${course.session} ${course.year})` ;
    } else if (course.year) {
      return `${course.name} (${course.year})` ;
    } else if (course.session) {
      return `${course.name} (${course.session})` ;
    } else {
      return course.name ;
    }
  }


  getInvite(code: string): Observable<Invite> {
    return this.http.get<Invite>(
      `${environment.apiHost}/invites/${code}`
    ) ;
  }

  acceptInvite(code: string): Observable<Enrollment> {
    return this.http.post<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {}
    )
  }

  getMyAcceptance(code: string): Observable<Enrollment> {

    return this.http.get<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees/me`
    ) ;
  }

  getAcceptances(code: string, page?: number): Observable<Page<User>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<User>>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {params}
    ) ;
  }

}
